/* eslint-disable import/prefer-default-export */

'use client';

import { useState, useEffect } from 'react';

export const useStickySectionScroll = () => {
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isSectionSticky, setIsSectionSticky] = useState(false);
  const [scrollTimeout, setScrollTimeout] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);

      // set a timeout to delay execution
      const timeout = setTimeout(() => {
        const currentScrollY =
          window.pageYOffset || document.documentElement.scrollTop;

        if (currentScrollY > lastScrollY) {
          // Scrolling down
          setIsSectionSticky(false); // only header sticky
        } else if (currentScrollY <= 12) {
          setIsSectionSticky(false);
        } else {
          // Scrolling up
          setIsSectionSticky(true); // section sticky
        }

        setLastScrollY(currentScrollY <= 0 ? 0 : currentScrollY);
      }, 12);

      setScrollTimeout(timeout);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);

      // clear any remaining timeout when the component unmounts
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, [lastScrollY, scrollTimeout]);

  return isSectionSticky;
};
